import { ArrowBack } from '@mui/icons-material';
import { Button } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router-dom'

function BackBTN() {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    };
    return (
        <Button
            startIcon={<ArrowBack />}
            variant="contained"
            onClick={goBack}
            sx={{ margin: '1rem', backgroundColor: '#2596BE	', color: 'white' }}
        >
            Retour
        </Button>
    );
}

export default BackBTN